import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmPopupViewedPayload {
  candidateId?: string;
}

/**
 * Fires when the "review additional applications" popup is shown after confirming a candidate.
 * Event: dental_portal:bulk_confirm:popup_viewed
 */
export function fireBulkConfirmPopupViewed(payload: IBulkConfirmPopupViewedPayload = {}): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:popup_viewed', {
    candidate_id: payload.candidateId,
  });
}
